/**
 * 判斷「這個 session 已經不存在」的錯誤。
 *
 * 會出現的來源（都算同一件事，使用者體驗要一致）：
 *   - `POST /api/sessions/:id/say|pm|join` 對已回收的 DO 回 404
 *   - Durable Object 被休眠後記憶體狀態掉了，回「session 不存在」
 *   - Worker 冷啟動後舊 session 已被清掉，回「已休眠 / dormant」
 *
 * 前端遇到這些不該只彈紅字：要把對話從清單移除（見 `useInbox.markInvalid`），
 * 不然使用者會一直對著死帳號按送出。
 */
const GONE_PATTERN = /不存在|已失效|休眠|dormant|expired|not\s*found|no\s*such\s*session|garbage\s*collected/i;
/** 這個錯誤是不是「session 死了、要重建成新帳號」？ */
export function isInvalidSessionError(err) {
    if (!err)
        return false;
    const status = typeof err.status === 'number' ? err.status : null;
    if (status === 404 || status === 410)
        return true;
    const message = err instanceof Error ? err.message : String(err);
    if (GONE_PATTERN.test(message)) {
        // 只有「跟 session／帳號有關」的訊息才算，避免把一般 404（例如 /api/rooms 端點沒上線）誤判成帳號死掉。
        return /session|帳號|身分|連線|帳戶|account/i.test(message) || status === 404;
    }
    return false;
}
//# sourceMappingURL=errors.js.map